import type { InjectionKey } from 'vue';

export type ModalCloseGuard = () => boolean | Promise<boolean>;

export type SetModalCloseGuard = (guard: ModalCloseGuard | null) => void;

export const setModalCloseGuardKey: InjectionKey<SetModalCloseGuard> =
  Symbol('setModalCloseGuard');
